<template>
  <div class="footer-word">

    <div style="width: 100%;padding: 10px;"> <!-- max-width: 1650px; -->

      <div style="text-align: left;margin-bottom: 30px;">
        <div style="text-align: left;display:inline-block;margin-right: 10px;" v-for="(item,index) in infolink_list" :key="index">
          <router-link :to="'/guide/'+item.urlname">
            {{ item.title }}
          </router-link>
        </div>
      </div>
      
      <div style="text-align: left;">
        <div style="text-align: left;display:inline-block;margin-right: 10px;" v-for="(item,index) in imglink_list" :key="index">
          <a :href="item.url" target="_blank"><img width="100" :src="item.img" :alt="item.title" /></a>
        </div>
      </div>


      <el-row :span="24" type="flex" justify="start" align="top">

        <el-col :xs="24" :sm="24" style="text-align: left;">
          
          <div class="footer-copyright">본 사이트는 인터넷상에서 수집된 다른 사이트에 대한 링크정보를 포함하고 있으며, 미디어 파일을 호스팅하거나 업로드하지 않습니다.</div>
          <div class="footer-copyright">일부 게시글에 대하여 삭제 처리를 도와드리고 있으며, 연락주시면 순차적으로 처리해드리고 있습니다.</div>
          <div class="footer-copyright">Copyright © 별별티비 All right reserved.</div>

        </el-col>

      </el-row>

    </div>
    
    
  </div>
</template>

<script>
export default {
  name: 'MyFooter',
  props: {
    // keys_:String,
  },
  data() {
    return {
      imglink_list:[],
      infolink_list:[]
    }
  },
  mounted() {
    
    var this_ = this


    this.httpinfo.GetInfo(this,this.baseURL + "footer?mark="+this.baseMark+"&footer-type=info-footer", function(e) {
      if(e.data.code==0){
        
        this_.imglink_list = e.data.data.data
        this_.infolink_list = e.data.data.footerpage==undefined?[]:e.data.data.footerpage

        // console.log(e.data.data.pageviews)
        this_.putCount(e.data.data)
        
      }

    });


  },
  methods: {
    putCount(value){
      this.$emit('putCount',value)
    }
  }
}
</script>


<style>
  .footer-word {
    padding: 20px 0;
    color: #BBBBBB;
    font-size: 14px;
    /* background-color: rgb(9, 9, 9); */
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;     /* 垂直居中 */
  }
  .footer-stit {
    padding-top: 20px;
    color: #FFF;
    font-size: 14px;
    text-align: right;
  }
  .footer-svalue {
    margin-top: 10px;
    text-align: right;
  }
  .footer-copyright {
    margin: 10px 0;
  }
</style>
